// extracted by mini-css-extract-plugin
module.exports = {"component":"EqualSizeGroup_component__2ZB84","isVertical":"EqualSizeGroup_isVertical__1vIxB"};